export default __webpack_public_path__ + "static/media/Q18_2_resized.b65cdf54.jpg";